// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/item.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/item.proto.
 */
export const file_inventory_v1_item: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types]);

/**
 * Item message definition
 *
 * @generated from message inventory.v1.Item
 */
export type Item = Message<"inventory.v1.Item"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID category_id = 2;
   */
  categoryId?: ID;

  /**
   * @generated from field: types.ID item_group_id = 3;
   */
  itemGroupId?: ID;

  /**
   * @generated from field: string sku_number = 4;
   */
  skuNumber: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: string notes = 7;
   */
  notes: string;

  /**
   * @generated from field: google.protobuf.Struct attribute_values = 8;
   */
  attributeValues?: JsonObject;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 9;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: string measurement_unit = 10;
   */
  measurementUnit: string;

  /**
   * @generated from field: string pricing_unit_override = 11;
   */
  pricingUnitOverride: string;

  /**
   * @generated from field: int32 color_hue = 12;
   */
  colorHue: number;

  /**
   * @generated from field: types.Base base = 13;
   */
  base?: Base;
};

/**
 * Describes the message inventory.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema: GenMessage<Item> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 0);

/**
 * Request/Response messages for Item queries
 *
 * @generated from message inventory.v1.GetItemRequest
 */
export type GetItemRequest = Message<"inventory.v1.GetItemRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetItemRequest.
 * Use `create(GetItemRequestSchema)` to create a new message.
 */
export const GetItemRequestSchema: GenMessage<GetItemRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 1);

/**
 * @generated from message inventory.v1.GetItemResponse
 */
export type GetItemResponse = Message<"inventory.v1.GetItemResponse"> & {
  /**
   * @generated from field: inventory.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message inventory.v1.GetItemResponse.
 * Use `create(GetItemResponseSchema)` to create a new message.
 */
export const GetItemResponseSchema: GenMessage<GetItemResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 2);

/**
 * @generated from message inventory.v1.ListItemsRequest
 */
export type ListItemsRequest = Message<"inventory.v1.ListItemsRequest"> & {
  /**
   * @generated from field: inventory.v1.ListItemsFilter filter = 1;
   */
  filter?: ListItemsFilter;

  /**
   * @generated from field: repeated inventory.v1.ItemSortOption sorting = 2;
   */
  sorting: ItemSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message inventory.v1.ListItemsRequest.
 * Use `create(ListItemsRequestSchema)` to create a new message.
 */
export const ListItemsRequestSchema: GenMessage<ListItemsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 3);

/**
 * @generated from message inventory.v1.ListItemsFilter
 */
export type ListItemsFilter = Message<"inventory.v1.ListItemsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue category_id = 2;
   */
  categoryId?: string;

  /**
   * @generated from field: google.protobuf.StringValue item_group_id = 3;
   */
  itemGroupId?: string;

  /**
   * @generated from field: google.protobuf.StringValue sku_number = 4;
   */
  skuNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 5;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 6;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 7;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue measurement_unit = 10;
   */
  measurementUnit?: string;

  /**
   * @generated from field: google.protobuf.StringValue pricing_unit_override = 11;
   */
  pricingUnitOverride?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 13;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 14;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.ListItemsFilter.
 * Use `create(ListItemsFilterSchema)` to create a new message.
 */
export const ListItemsFilterSchema: GenMessage<ListItemsFilter> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 4);

/**
 * @generated from message inventory.v1.ListItemsResponse
 */
export type ListItemsResponse = Message<"inventory.v1.ListItemsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Item items = 1;
   */
  items: Item[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message inventory.v1.ListItemsResponse.
 * Use `create(ListItemsResponseSchema)` to create a new message.
 */
export const ListItemsResponseSchema: GenMessage<ListItemsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 5);

/**
 * Command messages
 *
 * @generated from message inventory.v1.CreateItemRequest
 */
export type CreateItemRequest = Message<"inventory.v1.CreateItemRequest"> & {
  /**
   * @generated from field: inventory.v1.ItemInput input = 1;
   */
  input?: ItemInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CreateItemRequest.
 * Use `create(CreateItemRequestSchema)` to create a new message.
 */
export const CreateItemRequestSchema: GenMessage<CreateItemRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 6);

/**
 * @generated from message inventory.v1.CreateItemResponse
 */
export type CreateItemResponse = Message<"inventory.v1.CreateItemResponse"> & {
  /**
   * @generated from field: inventory.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message inventory.v1.CreateItemResponse.
 * Use `create(CreateItemResponseSchema)` to create a new message.
 */
export const CreateItemResponseSchema: GenMessage<CreateItemResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 7);

/**
 * @generated from message inventory.v1.UpdateItemRequest
 */
export type UpdateItemRequest = Message<"inventory.v1.UpdateItemRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: inventory.v1.ItemUpdateInput input = 2;
   */
  input?: ItemUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.UpdateItemRequest.
 * Use `create(UpdateItemRequestSchema)` to create a new message.
 */
export const UpdateItemRequestSchema: GenMessage<UpdateItemRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 8);

/**
 * @generated from message inventory.v1.UpdateItemResponse
 */
export type UpdateItemResponse = Message<"inventory.v1.UpdateItemResponse"> & {
  /**
   * @generated from field: inventory.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message inventory.v1.UpdateItemResponse.
 * Use `create(UpdateItemResponseSchema)` to create a new message.
 */
export const UpdateItemResponseSchema: GenMessage<UpdateItemResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 9);

/**
 * @generated from message inventory.v1.DeleteItemRequest
 */
export type DeleteItemRequest = Message<"inventory.v1.DeleteItemRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.DeleteItemRequest.
 * Use `create(DeleteItemRequestSchema)` to create a new message.
 */
export const DeleteItemRequestSchema: GenMessage<DeleteItemRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 10);

/**
 * Input messages
 *
 * @generated from message inventory.v1.ItemInput
 */
export type ItemInput = Message<"inventory.v1.ItemInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID category_id = 2;
   */
  categoryId?: ID;

  /**
   * @generated from field: types.ID item_group_id = 3;
   */
  itemGroupId?: ID;

  /**
   * @generated from field: string sku_number = 4;
   */
  skuNumber: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: string notes = 7;
   */
  notes: string;

  /**
   * @generated from field: google.protobuf.Struct attribute_values = 8;
   */
  attributeValues?: JsonObject;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 9;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: string measurement_unit = 10;
   */
  measurementUnit: string;

  /**
   * @generated from field: string pricing_unit_override = 11;
   */
  pricingUnitOverride: string;

  /**
   * @generated from field: int32 color_hue = 12;
   */
  colorHue: number;
};

/**
 * Describes the message inventory.v1.ItemInput.
 * Use `create(ItemInputSchema)` to create a new message.
 */
export const ItemInputSchema: GenMessage<ItemInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 11);

/**
 * @generated from message inventory.v1.ItemUpdateInput
 */
export type ItemUpdateInput = Message<"inventory.v1.ItemUpdateInput"> & {
  /**
   * @generated from field: types.ID category_id = 1;
   */
  categoryId?: ID;

  /**
   * @generated from field: types.ID item_group_id = 2;
   */
  itemGroupId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue sku_number = 3;
   */
  skuNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 4;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 5;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 6;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue attribute_values = 7;
   */
  attributeValues?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 8;
   */
  customAttributes?: string;

  /**
   * @generated from field: google.protobuf.StringValue measurement_unit = 9;
   */
  measurementUnit?: string;

  /**
   * @generated from field: google.protobuf.StringValue pricing_unit_override = 10;
   */
  pricingUnitOverride?: string;

  /**
   * @generated from field: google.protobuf.Int32Value color_hue = 11;
   */
  colorHue?: number;
};

/**
 * Describes the message inventory.v1.ItemUpdateInput.
 * Use `create(ItemUpdateInputSchema)` to create a new message.
 */
export const ItemUpdateInputSchema: GenMessage<ItemUpdateInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 12);

/**
 * GetItemsByCustomAttributeRequest - custom query request
 *
 * @generated from message inventory.v1.GetItemsByCustomAttributeRequest
 */
export type GetItemsByCustomAttributeRequest = Message<"inventory.v1.GetItemsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetItemsByCustomAttributeRequest.
 * Use `create(GetItemsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetItemsByCustomAttributeRequestSchema: GenMessage<GetItemsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 13);

/**
 * GetItemsByCustomAttributeResponse - custom query response
 *
 * @generated from message inventory.v1.GetItemsByCustomAttributeResponse
 */
export type GetItemsByCustomAttributeResponse = Message<"inventory.v1.GetItemsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Item result = 1;
   */
  result: Item[];
};

/**
 * Describes the message inventory.v1.GetItemsByCustomAttributeResponse.
 * Use `create(GetItemsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetItemsByCustomAttributeResponseSchema: GenMessage<GetItemsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 14);

/**
 * CheckItemSearchPermissionsRequest - custom query request
 *
 * @generated from message inventory.v1.CheckItemSearchPermissionsRequest
 */
export type CheckItemSearchPermissionsRequest = Message<"inventory.v1.CheckItemSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CheckItemSearchPermissionsRequest.
 * Use `create(CheckItemSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckItemSearchPermissionsRequestSchema: GenMessage<CheckItemSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 15);

/**
 * CheckItemSearchPermissionsResponse - custom query response
 *
 * @generated from message inventory.v1.CheckItemSearchPermissionsResponse
 */
export type CheckItemSearchPermissionsResponse = Message<"inventory.v1.CheckItemSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string result = 1;
   */
  result: string[];
};

/**
 * Describes the message inventory.v1.CheckItemSearchPermissionsResponse.
 * Use `create(CheckItemSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckItemSearchPermissionsResponseSchema: GenMessage<CheckItemSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item, 16);

/**
 * @generated from enum inventory.v1.ItemSortOption
 */
export enum ItemSortOption {
  /**
   * @generated from enum value: ITEM_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_SKU_NUMBER_ASC = 1;
   */
  SKU_NUMBER_ASC = 1,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_SKU_NUMBER_DESC = 2;
   */
  SKU_NUMBER_DESC = 2,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_NAME_ASC = 3;
   */
  NAME_ASC = 3,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_NAME_DESC = 4;
   */
  NAME_DESC = 4,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_UPDATED_AT_ASC = 7;
   */
  UPDATED_AT_ASC = 7,

  /**
   * @generated from enum value: ITEM_SORT_OPTION_UPDATED_AT_DESC = 8;
   */
  UPDATED_AT_DESC = 8,
}

/**
 * Describes the enum inventory.v1.ItemSortOption.
 */
export const ItemSortOptionSchema: GenEnum<ItemSortOption> = /*@__PURE__*/
  enumDesc(file_inventory_v1_item, 0);

/**
 * Services
 *
 * @generated from service inventory.v1.ItemQueriesService
 */
export const ItemQueriesService: GenService<{
  /**
   * @generated from rpc inventory.v1.ItemQueriesService.GetItem
   */
  getItem: {
    methodKind: "unary";
    input: typeof GetItemRequestSchema;
    output: typeof GetItemResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemQueriesService.ListItems
   */
  listItems: {
    methodKind: "unary";
    input: typeof ListItemsRequestSchema;
    output: typeof ListItemsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemQueriesService.GetItemsByCustomAttribute
   */
  getItemsByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetItemsByCustomAttributeRequestSchema;
    output: typeof GetItemsByCustomAttributeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckItemSearchPermissionsRequestSchema;
    output: typeof CheckItemSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_item, 0);

/**
 * @generated from service inventory.v1.ItemCommandsService
 */
export const ItemCommandsService: GenService<{
  /**
   * @generated from rpc inventory.v1.ItemCommandsService.CreateItem
   */
  createItem: {
    methodKind: "unary";
    input: typeof CreateItemRequestSchema;
    output: typeof CreateItemResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemCommandsService.UpdateItem
   */
  updateItem: {
    methodKind: "unary";
    input: typeof UpdateItemRequestSchema;
    output: typeof UpdateItemResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemCommandsService.DeleteItem
   */
  deleteItem: {
    methodKind: "unary";
    input: typeof DeleteItemRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_item, 1);

